import React, { useEffect } from "react";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard from "./pages/dashboard/Dashbaord";
import UserManagement from "./pages/userManagement/UserManagement";
// import Mentors from "./pages/mentors/Mentors";
import AdminPage from "./pages/admin/AdminPage";
import UserList from "./pages/techniciansTaskList/UserList";
import Login from "./pages/login/Login";
import Layout from "./components/layout/Layout";
import ResetPassword from "./pages/resetPassword/ResetPassword";
// import DatatableTest from "./pages/datatableTest/Test";
import "./App.scss";
import Unautherized from "./pages/unautherized/Unautherized";
import GeneralSettings from "./pages/generalSettings/GeneralSettings";
import ForgotPassword from "./pages/forgotPassword/ForgotPassword";
import ResetPasswordUsingResetLink from "./pages/forgotPassword/ResetPasswordUsingResetLink";
import Report from "./pages/report/report";
const App = () => {
  useEffect(() => {
  }, []);
  return (
    <AuthProvider>
      <ThemeProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />           
            
            <Route
              path="/"
              element={<Navigate to="/dashboard" />}
            />   
            <Route
              path="/dashboard"
              element={
                <Layout pageTitle="Dashboard">
                  <ProtectedRoute element={<Dashboard />}  />
                </Layout>
              }
            />   
            <Route
              path="/usermanagement"
              element={
                <Layout pageTitle="User Management">
                  <ProtectedRoute element={<UserManagement />}  />
                </Layout>
              }
            />  
            <Route
              path="/generalsettings"
              element={
                <Layout pageTitle="General Settings">
                  <ProtectedRoute element={<GeneralSettings />}  />
                </Layout>
              }
            />        
            <Route
              path="/techniciandashbaord"
              element={
                <Layout pageTitle="Technician's Dashboard" isDateEnabled={true}>
                  <ProtectedRoute element={<UserList   />} roles={["admin"]} />
                </Layout>
              }
            />
            <Route
              path="/report"
              element={
                <Layout pageTitle="Report">
                  <ProtectedRoute element={<Report />}  />
                </Layout>
              }
            />   

            <Route
              path="/unauthorized"
              element={
                <Layout>
                  <ProtectedRoute element={<Unautherized />} />
                </Layout>
              }
            />
            <Route
              path="/forgotpassword"
              element={<ForgotPassword />}
            />
            <Route
              path="/resetpassword/:token"
              element={<ResetPasswordUsingResetLink />}
            />
          </Routes>
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
};

export default App;
